<template>
  <v-btn
    icon
    class="table-refresh-button"
    :loading="loading"
    :disabled="loading"
    v-tooltip="tooltip('Refresh table')"
    @click="$emit('refresh')"
  >
    <v-icon>mdi-refresh</v-icon>
  </v-btn>
</template>

<script>
export default {
  emits: ['refresh'],

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    tooltip(content) {
      return {
        content,
        visible: this.$vuetifyDisplay.mdAndDown ? false : undefined
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-refresh-button {
  width: 42px;
  height: 42px;
  min-width: 42px;
  border: 1px solid #d9dde5;
  border-radius: 5px;
  box-shadow: none;
  color: $secondary-color;
}
</style>
